var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"justify-center py-16 greyBlue white--text text-break text-center"},[_c('h2',{staticClass:"text-h2"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }